import React, { Fragment } from 'react'
import { Typography } from 'antd'

const { Title } = Typography
const QuestHeader = ({ t, type }) => {
  return (
    <Fragment>
      <div className="create-quest" style={{ paddingBottom: "1.6rem", borderBottom: "1px solid #e8e8e8", marginBottom: "2.4rem" }}>
        <div className="create-quest__content">
          {type === "Create" && <Title level={3}>Create Treasure Hunt</Title>}
          {type === "Update" && <Title level={3}>Edit Treasure Hunt</Title>}
          <div>Create and edit your treasure hunt stops and locations</div>
        </div>
      </div>
    </Fragment>
  )
}

export default QuestHeader
